import { getEnv } from 'env/env';

export const GTM_CONTAINER_ID = getEnv('NEXT_PUBLIC_GTM_CONTAINER_ID');
